import { DeleteQueueRequest } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteDeleteQueueRequest extends BaseHttpService<DeleteQueueRequest.Model> implements DeleteQueueRequest {
  async delete(): Promise<DeleteQueueRequest.Model> {
    return await this.request('delete');
  }
}
